import {Component, prop, watch} from 'vue-property-decorator';

@Component({
    template: require('./print.html'),
    components: {}
})
export class Print {
    @prop(Object)
    state;


    close(e) {
        this.$root.printing = false;
    }

    print(type) {
        this.$emit('print', type);
    }

    save(e) {
        this.$emit('save', this.state.title);
        e.preventDefault();
        return false;
    }

    savenew() {
        this.$emit('savenew', this.state.title);
        return false;
    }
}
